import React from 'react';
import styled from 'styled-components';

interface ToggleProps extends Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'onClick'> {
  active: boolean;
  onToggle: () => void;
}

const StyledToggle = styled.button<{ $active: boolean }>`
  width: 44px;
  height: 24px;
  border-radius: 12px;
  background: ${({ $active, theme }) => ($active ? theme.colors.primary : theme.colors.backgroundTertiary)};
  position: relative;
  transition: background ${({ theme }) => theme.transitions.fast};
  flex-shrink: 0;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  &::after {
    content: '';
    position: absolute;
    top: 2px;
    left: ${({ $active }) => ($active ? '22px' : '2px')};
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background: white;
    box-shadow: ${({ theme }) => theme.shadows.sm};
    transition: left ${({ theme }) => theme.transitions.fast};
  }
`;

export const Toggle: React.FC<ToggleProps> = ({ active, onToggle, ...rest }) => (
  <StyledToggle type="button" $active={active} onClick={onToggle} aria-pressed={active} {...rest} />
);

export default Toggle;
